// extracted by mini-css-extract-plugin
export default {"input":"UiInput_input_uwI0M","error":"UiInput_error_oYAGu"};